import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // get 1'st', 2'nd', 3'rd', or 4'th'
  // https://stackoverflow.com/a/32696040/9433691
  function getOrdinal(number: number): string {
    if (!number) {
      return "";
    }

    const lastDigit = +number.toString().slice(-1);
    let suffix = "";

    // defined st/nd/rd/th (suffix)
    switch (lastDigit) {
      case 1:
        suffix = "st";
        break;
      case 2:
        suffix = "nd";
        break;
      case 3:
        suffix = "rd";
        break;
      default:
        suffix = "th";
    }
    return `${number}${suffix}`;
  }

  return {
    getOrdinal,
  };
}
